import { post, get as apiGet } from 'api'
import { getFormData } from 'utils/helperMethods'

export const get = async () => {
  return apiGet(`/Company/GetChannelSettings `)
}

export const update = async values => {
  const formData = getFormData(values)
  return post('/Company/SaveChannelSettings', formData)
}
